import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { I18nextProvider, useTranslation } from 'react-i18next';
import i18n from './helpers/i18n';
import { Header } from "./components/header/Header";
import { Hero } from "./components/hero/Hero";
import { About } from "./components/about/About";
import { ProductTransport, ProductStancane, ProductShelf } from "./components/products/Products";
import { Print } from "./components/print/Print";
import { Contact } from "./components/contact/Contact";
import { Footer } from "./components/footer/Footer";
import reportWebVitals from './reportWebVitals';

const sectionRoutes = {
    '/about':     'about',
    '/transport': 'transport',
    '/stancane':  'stancane',
    '/shelf':     'shelf',
    '/contact':   'contact',
};

const routeToSection = Object.entries(sectionRoutes).reduce((acc, [route, id]) => {
    acc[id] = route;
    return acc;
}, {});

const App = () => {
    const { t } = useTranslation();

    React.useEffect(() => {
        document.title = t('pageTitle');
    }, [t]);

    React.useEffect(() => {
        const path = window.location.pathname;
        const sectionId = sectionRoutes[path];
        if (sectionId) {
            setTimeout(() => {
                document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
            }, 300);
        }

        const sectionIds = ['hero', 'about', 'transport', 'stancane', 'shelf', 'contact'];

        const updateUrl = () => {
            const trigger = window.scrollY + window.innerHeight * 0.35;
            for (let i = sectionIds.length - 1; i >= 0; i--) {
                const el = document.getElementById(sectionIds[i]);
                if (el && el.offsetTop <= trigger) {
                    const id = sectionIds[i];
                    const newPath = id === 'hero' ? '/' : (routeToSection[id] || '/');
                    if (window.location.pathname !== newPath) {
                        window.history.replaceState(null, '', newPath);
                    }
                    break;
                }
            }
        };

        window.addEventListener('scroll', updateUrl, { passive: true });
        updateUrl();
        return () => window.removeEventListener('scroll', updateUrl);
    }, []);

    return (
        <>
            <Header />
            <main>
                <Hero />
                <About />
                <Print />
                <ProductTransport />
                <ProductStancane />
                <ProductShelf />
                <Contact />
            </main>
            <Footer />
        </>
    );
};

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <StrictMode>
        <I18nextProvider i18n={i18n}>
            <App />
        </I18nextProvider>
    </StrictMode>,
);

reportWebVitals();
